const meetingsToChatResp = {
    error: null,
    overall: {
        value: 0.45397579901948176,
        significance: "strong",
        explanation:
            "They are highly positively correlated, potentially meaning that days that you spend a high amount of time on meetings have a very high chance to be the days you chat a lot as well.",
        description:
            "For the entirety of time we have data on your meetings and chat, it seems that there is n strong positive correlation between the time spent in meetings and the time spent chatting in a day.that on days that you spend a high amount of time in meetings high amount of time spent on slack occurs as well and vice versa.",
        error: null,
    },
    smaller_frame: {
        value: 0.6076696165741996,
        significance: "strong",
        explanation:
            "They are highly positively correlated, potentially meaning that days that you spend a high amount of time on meetings have a very high chance to be the days you chat a lot as well.",
        description:
            "For last 2 weeks, it seems that there is n strong positive correlation between the time spent in meetings and the time spent chatting in a day.that on days that you spend a high amount of time in meetings high amount of time spent on slack occurs as well and vice versa.",
        frame_name: "Last 2 weeks",
        error: null,
    },
    graph: {
        data: [
            {
                datetime: "2023-04-24T00:00:00.000",
                meetings: 3600.0,
                chat: 4176.0,
                correlation: 0.3729975523,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-04-25T00:00:00.000",
                meetings: 5400.0,
                chat: 3973.0,
                correlation: 0.5458332502,
                trend_line: 3426.1151349752,
            },
            {
                datetime: "2023-04-26T00:00:00.000",
                meetings: 7200.0,
                chat: 4151.0,
                correlation: 0.6708317817,
                trend_line: 3353.0309853537,
            },
            {
                datetime: "2023-04-27T00:00:00.000",
                meetings: 3600.0,
                chat: 1788.0,
                correlation: 0.6732068791,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-04-28T00:00:00.000",
                meetings: 3600.0,
                chat: 2460.0,
                correlation: 0.6752089853,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-04-29T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.6919911105,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-04-30T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.7053221132,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-05-01T00:00:00.000",
                meetings: 3600.0,
                chat: 0.0,
                correlation: 0.6702135545,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-05-02T00:00:00.000",
                meetings: 3600.0,
                chat: 1568.0,
                correlation: 0.6717006808,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-05-03T00:00:00.000",
                meetings: 7200.0,
                chat: 518.0,
                correlation: 0.5583534832,
                trend_line: 3353.0309853537,
            },
            {
                datetime: "2023-05-04T00:00:00.000",
                meetings: 3600.0,
                chat: 2472.0,
                correlation: 0.5593446287,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-05-05T00:00:00.000",
                meetings: 3600.0,
                chat: 1572.0,
                correlation: 0.5393333703,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-05-06T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.5393333703,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-05-07T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.5829241244,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-05-08T00:00:00.000",
                meetings: 3600.0,
                chat: 3525.0,
                correlation: 0.5980642302,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-05-09T00:00:00.000",
                meetings: 3600.0,
                chat: 4651.0,
                correlation: 0.5984821192,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-05-10T00:00:00.000",
                meetings: 3600.0,
                chat: 3042.0,
                correlation: 0.5969700042,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-05-11T00:00:00.000",
                meetings: 3600.0,
                chat: 3291.0,
                correlation: 0.6302901206,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-05-12T00:00:00.000",
                meetings: 3600.0,
                chat: 1855.0,
                correlation: 0.5975981137,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-05-13T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.6051423584,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-05-14T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.65038644,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-05-15T00:00:00.000",
                meetings: 3600.0,
                chat: 5018.0,
                correlation: 0.5898275449,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-05-16T00:00:00.000",
                meetings: 3600.0,
                chat: 2670.0,
                correlation: 0.5319608493,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-05-17T00:00:00.000",
                meetings: 7200.0,
                chat: 5970.0,
                correlation: 0.6405799021,
                trend_line: 3353.0309853537,
            },
            {
                datetime: "2023-05-18T00:00:00.000",
                meetings: 3600.0,
                chat: 5024.0,
                correlation: 0.6240507585,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-05-19T00:00:00.000",
                meetings: 3600.0,
                chat: 1525.0,
                correlation: 0.5886621258,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-05-20T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.5886621258,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-05-21T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.6544378769,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-05-22T00:00:00.000",
                meetings: 3600.0,
                chat: 2259.0,
                correlation: 0.6619493518,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-05-23T00:00:00.000",
                meetings: 3600.0,
                chat: 1500.0,
                correlation: 0.8470093617,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-05-24T00:00:00.000",
                meetings: 3600.0,
                chat: 3629.0,
                correlation: 0.8502498791,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-05-25T00:00:00.000",
                meetings: 3600.0,
                chat: 2683.0,
                correlation: 0.8662113893,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-05-26T00:00:00.000",
                meetings: 3600.0,
                chat: 1438.0,
                correlation: 0.8331298675,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-05-27T00:00:00.000",
                meetings: 0.0,
                chat: 300.0,
                correlation: 0.8286970937,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-05-28T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.8418377653,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-05-29T00:00:00.000",
                meetings: 3600.0,
                chat: 600.0,
                correlation: 0.81450059,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-05-30T00:00:00.000",
                meetings: 3600.0,
                chat: 600.0,
                correlation: 0.7786289945,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-05-31T00:00:00.000",
                meetings: 7200.0,
                chat: 672.0,
                correlation: 0.6182528521,
                trend_line: 3353.0309853537,
            },
            {
                datetime: "2023-06-01T00:00:00.000",
                meetings: 3600.0,
                chat: 1532.0,
                correlation: 0.6150353198,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-06-02T00:00:00.000",
                meetings: 3600.0,
                chat: 600.0,
                correlation: 0.5718508905,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-06-03T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.5718508905,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-06-04T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.6244176396,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-06-05T00:00:00.000",
                meetings: 3600.0,
                chat: 0.0,
                correlation: 0.5936512632,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-06-06T00:00:00.000",
                meetings: 5400.0,
                chat: 1800.0,
                correlation: 0.4516233062,
                trend_line: 3426.1151349752,
            },
            {
                datetime: "2023-06-07T00:00:00.000",
                meetings: 3600.0,
                chat: 960.0,
                correlation: 0.518127944,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-06-08T00:00:00.000",
                meetings: 3600.0,
                chat: 3588.0,
                correlation: 0.4891978925,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-06-09T00:00:00.000",
                meetings: 3600.0,
                chat: 4486.0,
                correlation: 0.4200548211,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-06-10T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.4200548211,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-06-11T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.4505996984,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-06-12T00:00:00.000",
                meetings: 3600.0,
                chat: 5119.0,
                correlation: 0.4265213148,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-06-13T00:00:00.000",
                meetings: 3600.0,
                chat: 7444.0,
                correlation: 0.3742522765,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-06-14T00:00:00.000",
                meetings: 7200.0,
                chat: 4835.0,
                correlation: 0.4584860417,
                trend_line: 3353.0309853537,
            },
            {
                datetime: "2023-06-15T00:00:00.000",
                meetings: 3600.0,
                chat: 2859.0,
                correlation: 0.4649306509,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-06-16T00:00:00.000",
                meetings: 3600.0,
                chat: 1457.0,
                correlation: 0.440418618,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-06-17T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.440418618,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-06-18T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.4807782052,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-06-19T00:00:00.000",
                meetings: 3600.0,
                chat: 346.0,
                correlation: 0.4773486597,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-06-20T00:00:00.000",
                meetings: 3600.0,
                chat: 2656.0,
                correlation: 0.5954908691,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-06-21T00:00:00.000",
                meetings: 3600.0,
                chat: 6263.0,
                correlation: 0.5852141442,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-06-22T00:00:00.000",
                meetings: 3600.0,
                chat: 2263.0,
                correlation: 0.6063278579,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-06-23T00:00:00.000",
                meetings: 3600.0,
                chat: 722.0,
                correlation: 0.5602178255,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-06-24T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.5602178255,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-06-25T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.6204733308,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-06-26T00:00:00.000",
                meetings: 3600.0,
                chat: 2868.0,
                correlation: 0.6656796019,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-06-27T00:00:00.000",
                meetings: 5400.0,
                chat: 3184.0,
                correlation: 0.6802457575,
                trend_line: 3426.1151349752,
            },
            {
                datetime: "2023-06-28T00:00:00.000",
                meetings: 7200.0,
                chat: 2410.0,
                correlation: 0.6119740593,
                trend_line: 3353.0309853537,
            },
            {
                datetime: "2023-06-29T00:00:00.000",
                meetings: 3600.0,
                chat: 1485.0,
                correlation: 0.6060575017,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-06-30T00:00:00.000",
                meetings: 5400.0,
                chat: 1610.0,
                correlation: 0.5456594136,
                trend_line: 3426.1151349752,
            },
            {
                datetime: "2023-07-01T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.5456594136,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-07-02T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.5883548835,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-07-03T00:00:00.000",
                meetings: 3600.0,
                chat: 6167.0,
                correlation: 0.6263545559,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-07-04T00:00:00.000",
                meetings: 3600.0,
                chat: 5569.0,
                correlation: 0.5488277973,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-07-05T00:00:00.000",
                meetings: 3600.0,
                chat: 12661.0,
                correlation: 0.414010605,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-07-06T00:00:00.000",
                meetings: 3600.0,
                chat: 11100.0,
                correlation: 0.4011140631,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-07-07T00:00:00.000",
                meetings: 9000.0,
                chat: 1984.0,
                correlation: 0.2665692457,
                trend_line: 3105.9896534437,
            },
            {
                datetime: "2023-07-08T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.2665692457,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-07-09T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.3159969505,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-07-10T00:00:00.000",
                meetings: 3600.0,
                chat: 2864.0,
                correlation: 0.3166069158,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-07-11T00:00:00.000",
                meetings: 3600.0,
                chat: 4671.0,
                correlation: 0.317482536,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-07-12T00:00:00.000",
                meetings: 12600.0,
                chat: 2963.0,
                correlation: 0.243501749,
                trend_line: 3129.075164711,
            },
            {
                datetime: "2023-07-13T00:00:00.000",
                meetings: 3600.0,
                chat: 2238.0,
                correlation: 0.245921318,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-07-14T00:00:00.000",
                meetings: 3600.0,
                chat: 300.0,
                correlation: 0.2031844662,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-07-15T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.2031844662,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-07-16T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.2421930407,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-07-17T00:00:00.000",
                meetings: 3600.0,
                chat: 2968.0,
                correlation: 0.2423454229,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-07-18T00:00:00.000",
                meetings: 3600.0,
                chat: 2317.0,
                correlation: 0.2601068543,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-07-19T00:00:00.000",
                meetings: 3600.0,
                chat: 1233.0,
                correlation: 0.2593723662,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-07-20T00:00:00.000",
                meetings: 3600.0,
                chat: 2058.0,
                correlation: 0.274854275,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-07-21T00:00:00.000",
                meetings: 3600.0,
                chat: 1200.0,
                correlation: 0.2358174047,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-07-22T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.2358174047,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-07-23T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.2711922196,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-07-24T00:00:00.000",
                meetings: 3600.0,
                chat: 2114.0,
                correlation: 0.2701091414,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-07-25T00:00:00.000",
                meetings: 5400.0,
                chat: 4746.0,
                correlation: 0.3687806302,
                trend_line: 3426.1151349752,
            },
            {
                datetime: "2023-07-26T00:00:00.000",
                meetings: 7200.0,
                chat: 2768.0,
                correlation: 0.6183735483,
                trend_line: 3353.0309853537,
            },
            {
                datetime: "2023-07-27T00:00:00.000",
                meetings: 3600.0,
                chat: 2863.0,
                correlation: 0.6514074726,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-07-28T00:00:00.000",
                meetings: 3600.0,
                chat: 2691.0,
                correlation: 0.6230831593,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-07-29T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.6230831593,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-07-30T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.6532194795,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-07-31T00:00:00.000",
                meetings: 3600.0,
                chat: 7167.0,
                correlation: 0.5508493243,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-08-01T00:00:00.000",
                meetings: 3600.0,
                chat: 2197.0,
                correlation: 0.6681047874,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-08-02T00:00:00.000",
                meetings: 3600.0,
                chat: 4157.0,
                correlation: 0.6643604826,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-08-03T00:00:00.000",
                meetings: 3600.0,
                chat: 1858.0,
                correlation: 0.6952402711,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-08-04T00:00:00.000",
                meetings: 3600.0,
                chat: 2421.0,
                correlation: 0.6706864252,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-08-05T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.6706864252,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-08-06T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.6931425841,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-08-07T00:00:00.000",
                meetings: 3600.0,
                chat: 7014.0,
                correlation: 0.6383190619,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-08-08T00:00:00.000",
                meetings: 3600.0,
                chat: 3528.0,
                correlation: 0.658424289,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-08-09T00:00:00.000",
                meetings: 12600.0,
                chat: 611.0,
                correlation: 0.3175362024,
                trend_line: 3129.075164711,
            },
            {
                datetime: "2023-08-10T00:00:00.000",
                meetings: 3600.0,
                chat: 2289.0,
                correlation: 0.3226933035,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-08-11T00:00:00.000",
                meetings: 3600.0,
                chat: 4906.0,
                correlation: 0.2721823094,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-08-12T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.2721823094,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-08-13T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.3200127384,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-08-14T00:00:00.000",
                meetings: 3600.0,
                chat: 0.0,
                correlation: 0.2762803445,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-08-15T00:00:00.000",
                meetings: 3600.0,
                chat: 300.0,
                correlation: 0.2583997244,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-08-16T00:00:00.000",
                meetings: 3600.0,
                chat: 0.0,
                correlation: 0.2398091451,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-08-17T00:00:00.000",
                meetings: 3600.0,
                chat: 0.0,
                correlation: 0.2232313838,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-08-18T00:00:00.000",
                meetings: 3600.0,
                chat: 0.0,
                correlation: 0.1771855337,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-08-19T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.1771855337,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-08-20T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.2180452653,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-08-21T00:00:00.000",
                meetings: 3600.0,
                chat: 4766.0,
                correlation: 0.219420928,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-08-22T00:00:00.000",
                meetings: 5400.0,
                chat: 7557.0,
                correlation: 0.2804322927,
                trend_line: 3426.1151349752,
            },
            {
                datetime: "2023-08-23T00:00:00.000",
                meetings: 7200.0,
                chat: 4535.0,
                correlation: 0.333385938,
                trend_line: 3353.0309853537,
            },
            {
                datetime: "2023-08-24T00:00:00.000",
                meetings: 3600.0,
                chat: 2122.0,
                correlation: 0.3329578661,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-08-25T00:00:00.000",
                meetings: 3600.0,
                chat: 303.0,
                correlation: 0.2981789176,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-08-26T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.2981789176,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-08-27T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.3556720896,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-08-28T00:00:00.000",
                meetings: 3600.0,
                chat: 300.0,
                correlation: 0.3519622968,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-08-29T00:00:00.000",
                meetings: 3600.0,
                chat: 4391.0,
                correlation: 0.603716889,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-08-30T00:00:00.000",
                meetings: 3600.0,
                chat: 394.0,
                correlation: 0.5850356857,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-08-31T00:00:00.000",
                meetings: 3600.0,
                chat: 3765.0,
                correlation: 0.5939362235,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-09-01T00:00:00.000",
                meetings: 3600.0,
                chat: 1258.0,
                correlation: 0.5798630325,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-09-02T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.5798630325,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-09-03T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.6118477092,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-09-04T00:00:00.000",
                meetings: 3600.0,
                chat: 1914.0,
                correlation: 0.6311032888,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-09-05T00:00:00.000",
                meetings: 3600.0,
                chat: 7459.0,
                correlation: 0.6114696002,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-09-06T00:00:00.000",
                meetings: 7200.0,
                chat: 2865.0,
                correlation: 0.6070422206,
                trend_line: 3353.0309853537,
            },
            {
                datetime: "2023-09-07T00:00:00.000",
                meetings: 3600.0,
                chat: 4413.0,
                correlation: 0.6320939348,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-09-08T00:00:00.000",
                meetings: 3600.0,
                chat: 2043.0,
                correlation: 0.6064117937,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-09-09T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.6064117937,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-09-10T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.6333061457,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-09-11T00:00:00.000",
                meetings: 3600.0,
                chat: 5033.0,
                correlation: 0.5989587339,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-09-12T00:00:00.000",
                meetings: 3600.0,
                chat: 600.0,
                correlation: 0.5346167981,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-09-13T00:00:00.000",
                meetings: 3600.0,
                chat: 2102.0,
                correlation: 0.5344279585,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-09-14T00:00:00.000",
                meetings: 3600.0,
                chat: 2106.0,
                correlation: 0.5622259344,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-09-15T00:00:00.000",
                meetings: 3600.0,
                chat: 1200.0,
                correlation: 0.5213096408,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-09-16T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.5213096408,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-09-17T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.5796518584,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-09-18T00:00:00.000",
                meetings: 12600.0,
                chat: 5515.0,
                correlation: 0.6342466207,
                trend_line: 3129.075164711,
            },
            {
                datetime: "2023-09-19T00:00:00.000",
                meetings: 3600.0,
                chat: 1163.0,
                correlation: 0.6440404352,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-09-20T00:00:00.000",
                meetings: 3600.0,
                chat: 3586.0,
                correlation: 0.6454757494,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-09-21T00:00:00.000",
                meetings: 9000.0,
                chat: 1996.0,
                correlation: 0.5911986038,
                trend_line: 3105.9896534437,
            },
            {
                datetime: "2023-09-22T00:00:00.000",
                meetings: 7200.0,
                chat: 4194.0,
                correlation: 0.588387992,
                trend_line: 3353.0309853537,
            },
            {
                datetime: "2023-09-23T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.588387992,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-09-24T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.6130153459,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-09-25T00:00:00.000",
                meetings: 10800.0,
                chat: 4339.0,
                correlation: 0.76344885,
                trend_line: 2944.7510697334,
            },
            {
                datetime: "2023-09-26T00:00:00.000",
                meetings: 5400.0,
                chat: 1823.0,
                correlation: 0.7567071364,
                trend_line: 3426.1151349752,
            },
            {
                datetime: "2023-09-27T00:00:00.000",
                meetings: 3600.0,
                chat: 4603.0,
                correlation: 0.7510565743,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-09-28T00:00:00.000",
                meetings: 3600.0,
                chat: 1295.0,
                correlation: 0.7499089831,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-09-29T00:00:00.000",
                meetings: 3600.0,
                chat: 1551.0,
                correlation: 0.7338032969,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-09-30T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.7338032969,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-10-01T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.8170076216,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-10-02T00:00:00.000",
                meetings: 3600.0,
                chat: 1898.0,
                correlation: 0.8248375842,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-10-03T00:00:00.000",
                meetings: 3600.0,
                chat: 4016.0,
                correlation: 0.7911289086,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-10-04T00:00:00.000",
                meetings: 7200.0,
                chat: 1609.0,
                correlation: 0.7666810463,
                trend_line: 3353.0309853537,
            },
            {
                datetime: "2023-10-05T00:00:00.000",
                meetings: 3600.0,
                chat: 300.0,
                correlation: 0.7571505835,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-10-06T00:00:00.000",
                meetings: 3600.0,
                chat: 1653.0,
                correlation: 0.741646911,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-10-07T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.741646911,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-10-08T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.6797404034,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-10-09T00:00:00.000",
                meetings: 3600.0,
                chat: 4029.0,
                correlation: 0.6500319177,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-10-10T00:00:00.000",
                meetings: 3600.0,
                chat: 3781.0,
                correlation: 0.6458592259,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-10-11T00:00:00.000",
                meetings: 3600.0,
                chat: 6917.0,
                correlation: 0.59399276,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-10-12T00:00:00.000",
                meetings: 3600.0,
                chat: 4715.0,
                correlation: 0.5490021933,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-10-13T00:00:00.000",
                meetings: 3600.0,
                chat: 3794.0,
                correlation: 0.5143593376,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-10-14T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.5143593376,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-10-15T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.5337075299,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-10-16T00:00:00.000",
                meetings: 3600.0,
                chat: 3958.0,
                correlation: 0.5759304401,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-10-17T00:00:00.000",
                meetings: 3600.0,
                chat: 4415.0,
                correlation: 0.5767843505,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-10-18T00:00:00.000",
                meetings: 7200.0,
                chat: 6750.0,
                correlation: 0.6751863164,
                trend_line: 3353.0309853537,
            },
            {
                datetime: "2023-10-19T00:00:00.000",
                meetings: 3600.0,
                chat: 7081.0,
                correlation: 0.6574490449,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-10-20T00:00:00.000",
                meetings: 3600.0,
                chat: 2629.0,
                correlation: 0.6263536084,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-10-21T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.6263536084,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-10-22T00:00:00.000",
                meetings: 0.0,
                chat: 0.0,
                correlation: 0.6644440348,
                trend_line: 4.0251852267,
            },
            {
                datetime: "2023-10-23T00:00:00.000",
                meetings: 3600.0,
                chat: 3058.0,
                correlation: 0.662057611,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-10-24T00:00:00.000",
                meetings: 3600.0,
                chat: 13571.0,
                correlation: 0.6480455202,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-10-25T00:00:00.000",
                meetings: 3600.0,
                chat: 9623.0,
                correlation: 0.6749160598,
                trend_line: 3065.4821718201,
            },
            {
                datetime: "2023-10-26T00:00:00.000",
                meetings: 3600.0,
                chat: 782.0,
                correlation: 0.6633881649,
                trend_line: 3065.4821718201,
            },
        ],
        explanation:
            "This is the graph is showing the correlation between the daily time spent in meetings and the daily time spent chatting.\n            Any data points above the 0.2 and below the -0.2 lines have a statistically significant correlation.\n            ",
        description:
            "It has been produced by calculating the correlation coefficient on a rolling window of 20 days, in order to smoothen the curve and depict the general direction of the move while minimizing the noise. This means that we take a window of the 20 first days of data and we calculate the correlation coefficient, then we remove the oldest day and we add an earlier one, calculating again the correlation, and we keep doing that until we reach the end of the dataset, meaning yesterday.\n            \n            These have been the best settings we have found to be working better for this calculation. However, we will allow you to set this settings in any value you see more fit.\n            \n            Any data points above the 0.2 line have a statistically significant positive correlation, meaning when one of the variable increases the other one does too. Also any data points below -0.2 represent a\n            statistically significant negative correlation, meaning when one variable increases the other one does reduce. The higher or lower from 0 a data point is the more positively or negatively our two variables are correlated indicatign that they potentially affect each other more.\n            ",
        error: null,
    },
};
export default meetingsToChatResp;
